import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStatePostList = {
  postList: { data: null, loading: false, error: null },
};

export const postList = createAsyncThunk('user/postList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/post/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerPostList = {
  [postList.pending]: (state) => {
    state.postList.loading = true;
  },
  [postList.fulfilled]: (state, action) => {
    state.postList.loading = false;
    state.postList.data = action.payload;
    state.postList.error = null;
  },
  [postList.rejected]: (state, action) => {
    state.postList.data = null;
    state.postList.loading = false;
    state.postList.error = action.payload;
  },
};
